
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-linkedin_2"},[_c('path',{staticClass:"i-Vector",attrs:{"fill":"#798f8f","d":"M3.536 14.354H5.92V7.199H3.536zm2.541-9.359a1.234 1.234 0 0 0-1.32-1.24 1.24 1.24 0 1 0-.046 2.474 1.247 1.247 0 0 0 1.366-1.234m6.033 9.359h2.382v-4.099c0-2.198-1.174-3.22-2.745-3.22a2.34 2.34 0 0 0-2.152 1.207V7.2H7.232v7.155h2.383v-4a1.6 1.6 0 0 1 .073-.574 1.32 1.32 0 0 1 1.22-.871c.859 0 1.202.66 1.202 1.623zM16.934 4.05v9.9a2.976 2.976 0 0 1-2.97 2.97H4.051a2.976 2.976 0 0 1-2.957-2.97v-9.9a2.977 2.977 0 0 1 2.957-2.957h9.9a2.977 2.977 0 0 1 2.983 2.957"}})])])
          )
        }
      }
    